import { ExtractPropTypes } from 'vue'

export const breadcrumbProps = {
	/**
	 * 分隔符
	 */
	separator: {
		type: String,
		default: '/'
	},
	/**
	 * 图标分隔符
	 */
	separatorIcon: {
		type: String,
		default: ''
	},
	/**
	 * 模式
	 */
	mode: {
		type: String,
		default: 'default'
	},
	/**
	 * 是否启用 flex 布局
	 */
	flex: {
		type: Boolean,
		default: false
	}
}

export type BreadcrumbProps = ExtractPropTypes<typeof breadcrumbProps>
